import { inputClass } from "./common";

// Editable classification dropdown: choose from server-persisted categories
// (scoped per section), add a new one, or delete existing ones so the user
// can keep a single consistent format (all uppercase / lowercase).
export function CategoryField({ value, categories = [], onChange, onAddCategory, onDeleteCategory, deletableCategories = [], testid, allowNone = true }) {
  const opts = [...new Set([...(categories || []), ...(value ? [value] : [])].filter(Boolean))].sort((a, b) => a.localeCompare(b, "es"));
  const handle = async (e) => {
    const v = e.target.value;
    if (v === "__new__") {
      const n = window.prompt("Nombre de la nueva clasificación:");
      const nm = (n || "").trim();
      if (nm) { await onAddCategory?.(nm); onChange(nm); }
      return;
    }
    onChange(v);
  };
  const delSet = new Set(deletableCategories || []);
  const delList = opts.filter((c) => delSet.has(c));
  return (
    <div>
      <select data-testid={testid} className={inputClass} value={value || ""} onChange={handle}>
        {allowNone && <option value="">— Sin clasificación —</option>}
        {opts.map((c) => <option key={c} value={c}>{c}</option>)}
        <option value="__new__">＋ Agregar nueva clasificación…</option>
      </select>
      {onDeleteCategory && delList.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2">
          <span className="text-[11px] text-muted-foreground w-full">Borra las que no uses para dejar un solo formato (mayúsculas/minúsculas):</span>
          {delList.map((c) => (
            <span key={c} className="inline-flex items-center gap-1 text-[11px] bg-muted rounded-full pl-2 pr-1 py-0.5">
              {c}
              <button type="button" data-testid={`del-cat-${c}`} title={`Borrar "${c}"`}
                onClick={async () => { if (window.confirm(`¿Borrar la clasificación "${c}"? (no borra las fotos/documentos, solo la quita de la lista)`)) { await onDeleteCategory(c); if (c === value) onChange(""); } }}
                className="w-4 h-4 flex items-center justify-center rounded-full text-muted-foreground hover:text-white hover:bg-danger">×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
